import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const addHomeLinkSlice = createSlice({
  name: "addHomeLink",
  initialState,
  reducers: {
    addHomeLinkRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    addHomeLinkRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    addHomeLinkRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  addHomeLinkRequested,
  addHomeLinkRequestFailed,
  addHomeLinkRequestSucceeded,
} = addHomeLinkSlice.actions;

export default addHomeLinkSlice.reducer;
